import ko from 'knockout'
import Base from '../../core/base'
import util from './gridutil'
import getLang from '../../i18n'
import Ariaminxin from './mixin/ariamixin'
import fastDom from 'fastdom'
import eventlistener from '../../util/eventlistener'
class Body extends Base {
  initialize (params) {
    params.setBodyContext && params.setBodyContext(this)
    this.lazy = params.lazy
    this.i18nNoData = getLang('暂无数据')
    this.nodatapng = 'url(' + require('../../assets/nodata.png') + ')'
    this.hasSummaryRow = params.hasSummaryRow || false
    // 用在子表一对多的场景之中
    this.hasChildGrid = params.hasChildGrid || false
    this.isDataTable = params.isDataTable
    this.caculateColumns = params.caculateColumns
    this.expand = params.expand
    let _columns = params.columns
    this.columns = ko.observableArray(_columns())
    _columns.subscribe((vals) => {
      this.columns(vals)
      this.columns.splice(0, 0)
    })
    this.rows = params.rows
    this.domId = params.domId
    this.onRowSelect = params.onRowSelect
    this.defaultExpand = params.defaultExpand || false
    this.isNoDataCustomTpl = params.isNoDataCustomTpl || false
    this.lockhead = params.lockhead
    this.tdstyle = params.tdstyle
    this.isSeparate = params.isSeparate
    this.forbitRowSelect = params.forbitRowSelect || function () { }
    this.forbitRowSelectFn = params.forbitRowSelectFn || function () {
      return false
    }
    let tableFieldid = params.fieldid || ''
    if (tableFieldid) {
      tableFieldid = tableFieldid + '|'
    }
    this.getFieldId = (col, rowIndex, ColIndex) => {
      if (col.fieldid) {
        return tableFieldid + col.fieldid + '_cell_' + rowIndex
      } else if (col.field) {
        return tableFieldid + col.field + '_cell_' + rowIndex + '_' + ColIndex
      } else if (col.type === 'checkbox') {
        return tableFieldid + 'checkbox_cell_' + rowIndex
      }
    }
    this.isShowLoading = params.isShowLoading
    this.transform = params.transform
    this.headHeight = params.headHeight
    this.verticalAlign = params.verticalAlign
    this.lockColumnHeight = params.lockColumnHeight
    this.lockcolumn = ko.isObservable(params.lockcolumn) ? params.lockcolumn : ko.observable(params.lockcolumn || false)
    this.isLockLeft = params.isLockLeft || ko.observable(false)
    this.tableWidth = params.isLockLeft ? function () {
      return '100%'
    } : params.tableWidth
    this.computedLockColumnHeight = ko.observable({})
    // 每一行的高度（转换为数字的行高）
    this.columnNumberHeight = params.columnNumberHeight
    if (this.lockcolumn() && params.bodyrefs) {
      params.bodyrefs.leftBody = params.$el
    } else if (params.lockright && params.bodyrefs) {
      params.bodyrefs.rightBody = params.$el
    } else {
      if (params.bodyrefs) {
        params.bodyrefs.mainbody = params.$el.parentElement
      }
    }
    // 是否开启复杂
    this.aria = !!params.aria
    if (this.aria) {
      Ariaminxin.call(this, params)
    }
  }
  computed (params) {
    var that = this
    this.isEmtpyData = ko.computed(() => {
      return this.rows().length === 0
    })
    // 判断当前行是否显示（在lazy启用的状态下可能出现false）
    this.isTrShow = (row, index, lazy) => {
      return !lazy || (lazy && index >= lazy.lazyStart() && index <= lazy.lazyEnd())
    }
    // lazy场景上用于上方占位用的高度
    this.getUpHeight = ko.computed(() => {
      if (!this.lazy) {
        return 0
      } else {
        var start = this.lazy.lazyStart()
        // 如果
        if (start === 0) {
          return 0
        } else {
          var height = 0
          // 因为滚动的过程中lazyStart和lazyEnd 肯定会改变
          var heightNumbers = this.columnNumberHeight.peek()
          for (var i = 0; i < start; i++) {
            height += heightNumbers[i]
          }
          return height + 'px'
        }
      }
    })
    // lazy场景上用于下方占位用的高度
    this.getDownHeight = ko.computed(() => {
      var rowsLength = this.rows().length
      if (!this.lazy || rowsLength === 0) {
        return 0
      } else {
        var end = this.lazy.lazyEnd()
        // 如果
        if (end === rowsLength) {
          return 0
        } else {
          var height = 0
          var heightNumbers = this.columnNumberHeight.peek()
          for (var i = end + 1; i < rowsLength; i++) {
            height += heightNumbers[i]
          }
          return height + 'px'
        }
      }
    })
    this.getRowHeight = function (rowIndex) {
      if (params.isLockLeft || params.lazy) {
        return params.lockColumnHeight()[rowIndex] ? params.lockColumnHeight()[rowIndex].height : 'auto'
      } else {
        return 'auto'
      }
    }
    // 状态tab切换或重新加载不同数据后需要清空缓存的列高度
    // songhlc，只用处理非锁定的表格即可，最终都会修改lockColumnHeight 并触发getRowHeight
    if (!ko.utils.unwrapObservable(this.isLockLeft)) {
      this.rows.subscribe(function () {
        // 当调用addSimpleData的时候 需要只把原来没变化的设置成needRefresh=true 保留原来的高度（已经渲染过的不会重新走afterrender）
        var allHeight = this.computedLockColumnHeight()
        for (var prop in allHeight) {
          if (allHeight.hasOwnProperty(prop)) { // 这里扩展了对象,所以必须判断
            allHeight[prop].needRefresh = true
          }
        }
        that.computedLockColumnHeight(allHeight)
      }, this, 'beforeChange')
    }
    this.summaryAfterRender = (elements, data) => {
      ko.tasks.schedule(function () {
        var element = elements.filter(function (el) {
          return el.nodeName === 'TR'
        })[0]
        element.style.width = '100%'
      })
    }
    let lockcolumn = this.lockcolumn
    this.afterTrRender = (elements, data) => {
      //
    }
    let tdHeightCache = {}
    this.afterTdRender = (elements, data) => {
      // 只有启用锁定列 或 启用lazy 才计算
      if (!params.isLockLeft && (lockcolumn.peek() || params.lazy)) {
        var key = data.rowIndex + '_' + data.colIndex
        // 没有渲染过才需要渲染
        if (!tdHeightCache[key] || data.col.needRender) {
          var lockColumnHeight = that.computedLockColumnHeight.peek()
          // 找到parentTr
          fastDom.measure(() => {
            var pnode = elements[0].parentElement
            if (pnode && pnode.parentElement) {
              var height = pnode.parentElement.offsetHeight
              tdHeightCache[key] = height
              var oldHeight = lockColumnHeight[data.rowIndex]
              oldHeight = oldHeight ? oldHeight.height.replace('px', '') - 0 : undefined
              if (!oldHeight || height > oldHeight) {
                fastDom.mutate(() => {
                  lockColumnHeight[data.rowIndex] = {
                    height: height + 'px',
                    needRefresh: false
                  }
                  that.computedLockColumnHeight(lockColumnHeight)
                })
              }
            }
          })
        }
      }
    }
    // 要把行的afterRender 改成td的afterRender
    this.afterRender = (elements, data) => {
      // 只有启用锁定列才计算
      if (!params.isLockLeft && this.lockcolumn.peek()) {
        var lockColumnHeight = that.computedLockColumnHeight.peek()
        if (!lockColumnHeight[data.rowIndex] || lockColumnHeight[data.rowIndex].needRefresh) {
          ko.tasks.schedule(function () {
            var el = elements.filter(function (el) {
              return el.nodeName === 'TR'
            })[0]
            var i = 0
            // 这里因为不知道组件内部什么时候真正渲染完毕，所以循环了1s
            var _interval = setInterval(function () {
              fastDom.measure(() => {
                var height = el.offsetHeight
                fastDom.mutate(() => {
                  if (height > 0) {
                    clearInterval(_interval)
                    lockColumnHeight[data.rowIndex] = {
                      height: height + 'px',
                      needRefresh: false
                    }
                    that.computedLockColumnHeight({})
                    that.computedLockColumnHeight(lockColumnHeight)
                  }
                  i++
                  // 出于性能考虑以及可能存在的行高为0的情况不处理
                  if (i > 10) {
                    clearInterval(_interval)
                  }
                })
              })
            }, 100)
          })
        }
      }
    }
    // td渲染的不同模板
    this.displayMode = (data) => {
      switch (data.col.type) {
        case 'index':
          return 'y-template-index'
        case 'checkbox':
          return 'y-template-checkbox'
        case 'render':
          return 'y-template-render'
        case 'component':
          return 'y-template-component'
        case 'comp':
          return 'y-template-component'
        case 'operation':
          return 'y-template-operation'
        case 'text':
          return 'y-template-text'
        case 'rendertext':
          return 'y-template-rendertext'
        default:
          return 'y-template-noType'
      }
    }
    // 格式化表格默认值
    this.defaultFormatText = util.defaultFormatText
    this.formatText = util.formatText
    this.gridBodyStyle = ko.computed(() => {
      let style = {}
      if (this.lockhead) {
        if (ko.isObservable(this.headHeight)) {
          style.marginTop = this.headHeight()
        } else {
          style.marginTop = this.headHeight
        }
      }
      return style
    })
    // 计算暂无数据的单元格合并
    this.nodataColSpan = ko.computed(() => {
      if (params.columns && params.columns.subscribe) {
        return params.columns().length
      } else {
        return params.columns.length
      }
    })
    // 是否支持多选
    this.isMultiSelect = ko.computed(() => {
      if (params.columns.subscribe) {
        return params.columns().filter(col => {
          return col.type === 'checkbox'
        }).length > 0
      } else {
        return params.columns.filter(col => {
          return col.type === 'checkbox'
        }).length > 0
      }
    })
    this.expandColspan = ko.computed(() => {
      let count = 0
      this.columns().forEach(col => {
        if (ko.utils.unwrapObservable(col._show)) {
          count++
        }
      })
      return count
    })
    // 暂无数据区域的高度
    this.noDataHeight = ko.computed(() => {
      var maxheight = params.maxheight()
      if (maxheight === 'auto') {
        return 'auto'
      } else {
        return maxheight.replace('px', '') - 150 + 'px'
      }
    })
  }
  subscribe (params) {
    this.computedLockColumnHeight.subscribe((val) => {
      var length = this.rows.peek().length
      var count = 0
      for (var pro in val) {
        if (val.hasOwnProperty(pro)) { // 这里扩展了对象,所以必须判断
          count++
        }
      }
      // 如果所有的都渲染完了 count可能比实际数量多（重新setSimpleData 数量变少）
      if ((length <= count && length > 0) || params.lazy) {
        params.lockColumnHeight(val)
      }
    })
  }
  created (params) {
    if (params.rowspan) {
      setTimeout(() => {
        if (params.rows.peek().length > 0) {
          ko.tasks.schedule(function () {
            if (params.rowspan.columnIndex) {
              this.caculateRowspanByIndex(params.rowspan.columnIndex, params.domId, this)
            } else if (params.rowspan.maxCol) {
              this.caculateRowspan(params.rowspan.maxCol, params.domId, this)
            }
            if (params.rowspan.fields) {
              this.caculateRowspanByFields(params.rowspan.fields, params.domId, this)
            }
          }.bind(this))
        }
      })
      params.rows.subscribe(val => {
        // 确保子组件重绘之后再进行合并单元格，component调用的是后会遇到此问题
        setTimeout(function () {
          ko.tasks.schedule(function () {
            if (params.rowspan.columnIndex) {
              this.caculateRowspanByIndex(params.rowspan.columnIndex, params.domId, this)
            } else if (params.rowspan.maxCol) {
              this.caculateRowspan(params.rowspan.maxCol, params.domId, this)
            }
            if (params.rowspan.fields) {
              this.caculateRowspanByFields(params.rowspan.fields, params.domId, this)
            }
          }.bind(this))
        }.bind(this))
      })
    }
  }
  // 判断点击事件是否触发行选中
  isTriggerRowSelect (evt) {
    // 如果点击的是input则不触发
    if (evt.target.tagName === 'INPUT') {
      return false
    }
    if (evt.target.tagName === 'A') {
      return false
    }
    if (evt.target.classList.contains('y-grid-stoprowselect') || evt.target.classList.contains('y-grid-operation') || evt.target.classList.contains('y-select-single')) {
      return false
    }
    return true
  }
  needRowCombine (columnIndex, rowIndex, val, tabItem, i, delta) {
    var rowCombineFn = this.columns.peek()[columnIndex].needRowCombine
    if (rowCombineFn) {
      return rowCombineFn(this.rows()[rowIndex]) === val
    } else {
      return val === tabItem.innerHTML
    }
  }
  caculateRowspanByFields (fields, domId, context) {
    var columns = this.columns.peek()
    var indexes = []
    columns.forEach((col, index) => {
      if (fields.indexOf(col.field) > -1) {
        indexes.push(index)
      }
    })
    if (indexes.length > 0) {
      this.caculateRowspanByIndex(indexes, domId, this)
    }
  }
  caculateRowspanByIndex (indexes, domId, context) {
    var tab = document.getElementById(domId)
    // fix列动态的情况下会出问题 添加异常判断
    if (!tab) {
      return
    }
    // val表示单元格的内容
    let val = ''
    let count = 0
    let start = 0
    let endCaculateRowStart = 0
    indexes.forEach(index => {
      // 不同列的合并开始每次需要重置val值
      val = ''
      count = 1
      var delta = 0
      // 需要减掉用于显示暂无数据的那一行
      for (var i = 0; i < tab.rows.length - 1; i++) {
        // delta用于计算无用的行 确保后续的i-delta能取到正确的数据行
        if (tab.rows[i].classList.contains('stopCaculate')) {
          delta++
        }
        // fixed rowspan 在数据切换之后产生的bug
        if (tab.rows[i].cells[index] && !tab.rows[i].classList.contains('stopCaculate') && !tab.rows[i].cells[index].classList.contains('hide-by-col')) {
          // fixed rowspan 在数据切换之后产生的bug
          if (tab.rows[i].cells[index].style.display === 'none') {
            tab.rows[i].cells[index].style.display = 'table-cell'
          }
          // 每次初始化之前要把当前rowSpan重置
          tab.rows[i].cells[index].rowSpan = 1
          // 第一列不需要校验左侧是否被合并了（display === 'none'表示被合并了）
          if (this.needRowCombine(index, i - delta, val, tab.rows[i].cells[index])) {
            count++
          } else {
            if (count > 1) { // 合并
              start = i - count
              tab.rows[start].cells[index].rowSpan = count
              for (let j = start + 1; j < i; j++) {
                // 被合并的列隐藏
                tab.rows[j].cells[index].style.display = 'none'
              }
              count = 1
            }
            var needRowCombineFn = this.columns.peek()[index].needRowCombine
            var lastRowValue = needRowCombineFn ? needRowCombineFn(this.rows.peek()[i - delta]) : tab.rows[i].cells[index].innerHTML
            val = lastRowValue
          }
          endCaculateRowStart = i + 1
        }
      }
      if (count > 1) { // 合并，最后几行相同的情况下
        start = endCaculateRowStart - count
        tab.rows[start].cells[index].rowSpan = count
        for (let j = start + 1; j < endCaculateRowStart; j++) {
          if (!tab.rows[j].classList.contains('stopCaculate')) {
            tab.rows[j].cells[index].style.display = 'none'
          }
        }
      }
    })
  }
  // 动态计算rowspan
  caculateRowspan (maxColumns, domId, context, deltaStart) {
    var tab = document.getElementById(domId)
    // lazy的情况下需要额外传入默认起始行
    if (!deltaStart || deltaStart < 0) {
      deltaStart = 0
    }
    // fix列动态的情况下会出问题 添加异常判断
    if (!tab) {
      return
    }
    var maxCol = maxColumns
    let val = ''
    let count = 0
    let start = 0
    let endCaculateRowStart = 0
    // fix by songhlc 从左边第一列开始判断
    for (var col = 0; col <= maxCol - 1; col++) {
      count = 1
      val = ''
      var delta = 0
      // 需要减掉用于显示暂无数据的那一行
      for (var i = 0; i < tab.rows.length - 1; i++) {
        // delta用于计算无用的行 确保后续的i-delta能取到正确的数据行
        if (tab.rows[i].classList.contains('stopCaculate')) {
          delta++
        }
        var curCol = tab.rows[i].cells[col]
        // fixed rowspan 在数据切换之后产生的bug
        if (curCol && !tab.rows[i].classList.contains('stopCaculate') && !curCol.classList.contains('hide-by-col')) {
          if (curCol.style.display === 'none') {
            curCol.style.display = 'table-cell'
          }
          // 每次初始化之前要把当前rowSpan重置
          curCol.rowSpan = 1
          // 第一列不需要校验左侧是否被合并了（display === 'none'表示被合并了）
          if (this.needRowCombine(col, i - delta + deltaStart, val, curCol, i, delta) && (col === 0 || tab.rows[i].cells[col - 1].style.display === 'none')) {
            count++
          } else {
            if (count > 1) { // 合并
              start = i - count
              tab.rows[start].cells[col].rowSpan = count
              for (let j = start + 1; j < i; j++) {
                // 被合并的列隐藏
                tab.rows[j].cells[col].style.display = 'none'
              }
              count = 1
            }
            var needRowCombineFn = this.columns.peek()[col].needRowCombine
            var lastRowValue = needRowCombineFn ? needRowCombineFn(this.rows.peek()[i - delta + deltaStart]) : tab.rows[i].cells[col].innerHTML
            val = lastRowValue
          }
          endCaculateRowStart = i + 1
        }
      }
      if (count > 1) { // 合并，最后几行相同的情况下
        start = endCaculateRowStart - count
        tab.rows[start].cells[col].rowSpan = count
        for (let j = start + 1; j < endCaculateRowStart; j++) {
          if (!tab.rows[j].classList.contains('stopCaculate')) {
            tab.rows[j].cells[col].style.display = 'none'
          }
        }
      }
    }
  }
  methods (params) {
    // ariamixin中具体实现
    this.onBodyClick = this.onBodyClick || function () {
      return true
    }
    // ariamixin中具体实现
    this.onBodyKeyDown = this.onBodyKeyDown || function () {
      return true
    }
    this.handleBodyScroll = params.handleBodyScroll
    this.handleMouseOut = (row) => {
      row._hover(false)
      return true
    }
    // mousein
    this.handleMouseIn = (row) => {
      if (row._hover()) return true
      row._hover(true)
      return true
    }
    this.holdKeyInstance = eventlistener.addKeyHoldListener()
    // 上一个选中的数据
    this.lastSelectedRowIndex = ko.observable()
    this.handleClick = (row, evt, index) => {
      // 如果组织行选中则直接返回不选中任何行
      if (this.forbitRowSelect() || this.forbitRowSelectFn(row)) {
        return false
      }
      // 对于一些输入框不选中
      if (!this.isTriggerRowSelect(evt)) {
        return true
      }
      // todo:需要将选中的数据放入缓存当中或从缓存中剔除
      if (this.isMultiSelect()) {
        let _selected = !row._selected()
        row._selected(_selected)
        var holdKey = this.holdKeyInstance.get()
        if (holdKey && holdKey.length > 0) {
          // 如果按下了shift键 且 和上一次选中的不是同一行
          if (this.holdKeyInstance.isHoldKeyCode(16) && index !== this.lastSelectedRowIndex()) {
            let min = Math.min(index, this.lastSelectedRowIndex())
            let max = Math.max(index, this.lastSelectedRowIndex())
            this.rows().forEach((r, index) => {
              if (index >= min && index <= max) {
                r._selected && r._selected(_selected)
              }
            })
          }
        }
        this.lastSelectedRowIndex(index)
      } else {
        // 一些单行选中的场景
        this.onRowSelect && this.onRowSelect(row)
      }
      // return true
    }
  }
}
export default Body



// WEBPACK FOOTER //
// ./src/components/grid/bodybase.js